import { render, staticRenderFns } from "./project-statuses-manual.vue?vue&type=template&id=7b18abeb"
import script from "./project-statuses-manual.vue?vue&type=script&lang=js"
export * from "./project-statuses-manual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports